import { useState } from "react";
import { Box, Alert } from "@mui/material";
import PageContainer from "../page-container/page-container";
import ClientListTable from "./components/client-list-table";
import ClientFilesView from "./components/client-files-view";
import LoadingScreen from "../progress/loading-screen";
import { useFileMonitorLogic } from "./hooks/use-file-monitor-logic";
import { useFileActions } from "./hooks/use-file-actions";
import { ClientInformation } from "../client-config/data/types";

const FileMonitor = () => {
  const {
    selectedClient,
    clients,
    isLoading,
    error,
    clientFiles,
    isLoadingMoreFiles,
    loadMoreFilesError,
    expectedFileCount,
    handleRetryLoadingFiles,
    handleViewClient,
    handleBackToList,
    handleRefresh,
    getFileCount,
  } = useFileMonitorLogic();

  const { onDeleteFile, onDownloadFile, onReprocessFile } = useFileActions();
  const [searchValue, setSearchValue] = useState<ClientInformation | null>(
    null,
  );

  const filteredClients =
    clients && searchValue
      ? clients.filter((client) => client.id === searchValue.id)
      : clients;

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (error) {
    return (
      <Box sx={{ flexGrow: 1 }}>
        <Alert severity="error">Unable to load file information</Alert>
      </Box>
    );
  }

  return (
    <PageContainer title="File Monitor" maxHeight="900px">
      <Box sx={{ px: 2 }}>
        {selectedClient ? (
          <ClientFilesView
            client={selectedClient}
            files={clientFiles}
            onBackToList={handleBackToList}
            onDeleteFile={(file) => onDeleteFile(file, handleRefresh)}
            onDownloadFile={onDownloadFile}
            onReprocessFile={(file) => onReprocessFile(file, handleRefresh)}
            isLoadingMore={isLoadingMoreFiles}
            expectedFileCount={expectedFileCount}
            loadMoreError={loadMoreFilesError}
            onRetryLoading={handleRetryLoadingFiles}
          />
        ) : (
          <ClientListTable
            clients={filteredClients || []}
            allClients={clients || []}
            onViewClient={handleViewClient}
            getFileCount={getFileCount}
            searchValue={searchValue}
            onClientSearchChange={setSearchValue}
          />
        )}
      </Box>
    </PageContainer>
  );
};

export default FileMonitor;
